import React, { useState } from 'react';
import { ModalContext } from 'utils/context';
import Trash from 'components/icons/Trash';
import { inputRequired, inputVerifyMail } from 'components/generics/Validators/validator';
import { validateFormData } from '../Validators/form.validate';
import './reportModal.style.scss';
import { Button, ThemeProvider } from '@mui/material';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import { useTranslation } from 'react-i18next';

export const ReportModal = ({ techniciansAddressMailList }) => {
  const MAIL_FORM = { mail: '' };
  const [listMailUser, setListMailUser] = useState(techniciansAddressMailList);
  const [checkEmptyListUserMail, setCheckEmptyListUserMail] = useState(false);
  const [errorsFormDefault, setErrorsFormDefault] = useState({
    formError: false,
    mail: {
      message: '',
      validator: [inputRequired, inputVerifyMail],
    },
  });
  const { t } = useTranslation();

  const sendSimulation = (context) => {
    if (listMailUser.length === 0) {
      setCheckEmptyListUserMail(true);
    } else {
      context.setConfirmSendReport(true);
      context.setListMailUserFromModal(listMailUser);
      context.toggleModal();
    }
  };

  const addMail = () => {
    errorsFormDefault.formError = false;
    const inputValue = document.getElementById('mail').value;
    MAIL_FORM.mail = inputValue;
    setErrorsFormDefault({ ...validateFormData(MAIL_FORM, errorsFormDefault) });
    if (!errorsFormDefault.formError) {
      setListMailUser((current) => [...current, inputValue]);
      document.getElementById('mail').value = null;
      setCheckEmptyListUserMail(false);
    }
  };

  const removeMail = (i) => {
    setListMailUser((current) => current.filter((_, index) => index !== i));
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') addMail();
  };

  return (
    <ModalContext.Consumer>
      {(context) => {
        if (!context.showModal) return null;
        return (
          <ThemeProvider theme={customButtonTheme}>
            <div className="report-modal">
              <div className="report-modal__content">
                <p className="report-modal__title">{t('message.EmailReportTitle')}</p>

                <p style={{ marginBottom: '12px', fontSize: '0.9rem' }}>
                  {t('message.reportEmailListTitle')}
                </p>

                <div className="report-modal__mail-list">
                  {listMailUser.map((mail, i) => (
                    <div key={'mail' + i} className="report-modal__mail-row">
                      <p>{mail}</p>
                      <span className="report-modal__mail-remove" onClick={() => removeMail(i)}>
                        <Trash fill="#e69636" color="#e69636" width={18} height={18} />
                      </span>
                    </div>
                  ))}
                </div>

                {errorsFormDefault?.mail.message && (
                  <p className="report-modal__error">{errorsFormDefault.mail.message}</p>
                )}

                <div className="report-modal__add-form">
                  <div>
                    <label htmlFor="mail">{t('message.reportEmailLabel')}</label>
                    <input id="mail" placeholder={t('placeholder.email')} onKeyUp={handleKeyUp} />
                  </div>
                  <Button variant="outlined" size="small" onClick={addMail}>
                    {t('common.add')}
                  </Button>
                </div>

                {checkEmptyListUserMail && (
                  <p className="report-modal__error">{t('message.reportNoEmailEntered')}</p>
                )}

                <div className="report-modal__actions">
                  <Button variant="outlined" onClick={context.toggleModal}>
                    {t('common.cancel')}
                  </Button>
                  <Button variant="contained" onClick={() => sendSimulation(context)}>
                    {t('common.confirm')}
                  </Button>
                </div>
              </div>
            </div>
          </ThemeProvider>
        );
      }}
    </ModalContext.Consumer>
  );
};
